<article class="z-40" [ngClass]="{'absolute -mt-3 -ml-3': absolute()}">
    <div class="flex justify-center items-end">
        <div class="flex rounded-[50%] justify-center items-center" [ngStyle]="styles">
            <div class="rounded-[50%] bg-white" [ngStyle]="whiteDotStyles"></div>
            @if (count() && count()! > 1) {
                <span class="absolute font-bold">{{ count() }}</span>
            }
        </div>
    </div>
</article>